<template>
    <v-card class="message elevation-0 pa-0" max-width="48rem">
        <v-card-text>
            <v-row no-gutters class="text-caption">
                <v-col cols="12">
                    {{ $t('Register_your_user_ID_with_multifactor_authentication.') }}
                </v-col>
                <v-col cols="12" class="mb-3">
                    {{
                        $t(
                            'Prepare_smartphone_or_tablet_with_Google_Authenticator_installed_in_advance,_and_start_the_Google_Authenticator_application.'
                        )
                    }}
                </v-col>
                <v-col cols="12" class="mb-3">
                    {{ $t('Flow_of_registration') }}
                    <ol>
                        <li>{{ $t('Launch_the_Google_Authenticator_application_on_a_smartphone_or_tablet') }}</li>
                        <li>
                            {{ $t('Press_the_registration_button_to_register_for_multi-factor_authentication') }}
                        </li>
                        <li>{{ $t('The_QR_code_is_displayed_when_the_registration_process_is_complete') }}</li>
                        <li>{{ $t('Load_the_QR_code_with_the_camera_of_Google_Authenticator_on_the_device') }}</li>
                        <li>{{ $t('Your_one-time_password_is_displayed_on_Google_Authenticator') }}</li>
                    </ol>
                </v-col>

                <v-col cols="12" class="mb-3">
                    <alert-warning>
                        {{ $t('Registration_process_and_QR_code_can_be_issued_only_once.') }}
                        {{ $t('Please_note_that_you_can_not_re-register_or_re-issue.') }}
                    </alert-warning>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <button-app-control
                ref="cancel-btn"
                text
                :label="$t('Cancel')"
                :disabled="isRegisterProcessing"
                @click="closeDialog()"
            />
            <button-app-control
                ref="submit-btn"
                :label="$t('Registration')"
                :loading="isRegisterProcessing"
                :disabled="isRegisterProcessing"
                @click="deviceRegister()"
            />
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AlertWarning, ButtonAppControl } from '../../atoms';

@Component({
    name: 'CardRegisterConfirmation',
    components: {
        AlertWarning,
        ButtonAppControl,
    },
})
export default class CardRegisterConfirmation extends Vue {
    @Prop({ default: false }) isProcessing: boolean;

    /**
     * getter, setter
     */
    get isRegisterProcessing(): boolean {
        return this.isProcessing;
    }

    /**
     * methods
     */
    closeDialog(): void {
        this.$emit('closeDialog');
    }
    deviceRegister(): void {
        this.$emit('register');
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
